import { Button } from "@/components/ui/button";
import { LucideIcon } from "lucide-react";
import { motion } from "framer-motion";
import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode | {
    label: string;
    icon: LucideIcon;
    onClick: () => void;
  };
}

export function PageHeader({ title, description, action }: PageHeaderProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="flex flex-col sm:flex-row sm:items-center justify-between gap-4"
    >
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground">{title}</h1>
        {description && (
          <p className="text-muted-foreground mt-2">{description}</p>
        )}
        <div className="flex items-center mt-2">
          <div className="w-12 h-0.5 bg-primary"></div>
          <div className="w-2 h-2 bg-primary mx-2 rotate-45"></div>
          <div className="w-12 h-0.5 bg-primary"></div>
        </div>
      </div>
      {action && (
        <>
          {typeof action === 'object' && 'label' in action ? (
            <Button
              onClick={action.onClick}
              className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-md hover:shadow-lg transition-all duration-300"
            >
              <action.icon className="w-4 h-4 mr-2" />
              {action.label}
            </Button>
          ) : (
            action
          )}
        </>
      )}
    </motion.div>
  );
}